import { use } from 'react';

import type { TimezoneContextProps } from '../contexts/timezone-context';
import { TimezoneContext } from '../contexts/timezone-context';

export const useTimezone = (): TimezoneContextProps => {
  const context = use(TimezoneContext);

  if (!context) {
    throw new Error('useTimezone must be used within a TimezoneProvider');
  }
  return context;
};
